import 'react-app-polyfill/stable'
import 'core-js'
import '@fortawesome/fontawesome-free/css/all.min.css'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import { Provider } from 'react-redux'
import store from './store'

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <App />
  </Provider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

// Registers a service worker so Chrome can fire `beforeinstallprompt` (required for the
// custom "Install Web App" button) and the app can be installed/used offline.
//
// A new build installs its service worker in the background but the old one keeps
// serving cached assets until every tab is closed (see service-worker.js). To avoid
// users getting stuck on stale builds, tell the waiting worker to activate immediately
// and reload once it takes over.
let refreshingForUpdate = false
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshingForUpdate) return
    refreshingForUpdate = true
    window.location.reload()
  })
}

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    registration.waiting?.postMessage({ type: 'SKIP_WAITING' })
  },
})

// The browser only checks for a new service worker on navigation, which an
// installed PWA left open for days may never do. Also check whenever the app
// regains focus so updates are picked up promptly.
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    navigator.serviceWorker?.getRegistration().then((registration) => registration?.update())
  }
})
